document.addEventListener('DOMContentLoaded', function() {
  function updateAnnouncementBar() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var items = cart.items;
        var has250gBags = items.filter(item => item.title.includes('250g')).length;
        var announcementElement = document.querySelector('.hextom-announcement-bar-class'); // Replace with the actual class or ID

        if (announcementElement) {
          if (has250gBags === 0) {
            announcementElement.textContent = 'Right now: Buy 3 small bags, pay for two';
          } else if (has250gBags === 1) {
            announcementElement.textContent = 'Add one more bag and get one bag for free';
          } else if (has250gBags === 2) {
            announcementElement.textContent = 'Congrats! Choose one more small bag, no extra charge';
          } else {
            announcementElement.textContent = ''; // Optional: hide the message
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  updateAnnouncementBar();
  setInterval(updateAnnouncementBar, 5000); // Update every 5 seconds
});

